import Player from 'source/app/domain/Player';

export function GetTodaysExpectedProgress() {
	const currentHour = new Date().getHours() + new Date().getMinutes() / 60;

	const startingHour = Player.startingHour;
	const endingHour = Player.endingHour;

	const expectedProgress =
		(currentHour - startingHour) / (endingHour - startingHour);

	const progressPercent = expectedProgress * 100;
	return Math.min(progressPercent, 100);
}

export function GetTodaysActualProgress(kipsToday: number, kipsTarget: number) {
	const progress = kipsToday / kipsTarget;
	const progressPercent = progress * 100;
	return progressPercent;
}

export function GetAheadByTime(kipsToday: number, kipsTarget: number) {
	const expectedProgress = GetTodaysExpectedProgress();

	const actualProgress = GetTodaysActualProgress(kipsToday, kipsTarget);

	const hoursInDay = Player.endingHour - Player.startingHour;

	const timeAheadBy = hoursInDay * (actualProgress - expectedProgress) * 0.01;

	const hours =
		timeAheadBy >= 0 ? Math.floor(timeAheadBy) : Math.ceil(timeAheadBy);

	const minutes = Math.round((timeAheadBy % 1) * 60);

	return {
		hours,
		minutes
	};
}
